import { render } from "./mvt-cardmortgage-new.vue?vue&type=template&id=2627aa49"
import script from "./mvt-cardmortgage-new.js?vue&type=script&lang=js"
export * from "./mvt-cardmortgage-new.js?vue&type=script&lang=js"

import "./mvt-cardmortgage-new.vue?vue&type=style&index=0&id=2627aa49&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__